import { useState } from "react";
import { Link } from "react-router-dom";
import { SignOut, House } from "@phosphor-icons/react";
import { Logo } from "@/components/common";
import { useAuth } from "@/lib/auth";
import Overview from "./Overview";
import Hosts from "./Hosts";
import AdminOrders from "./AdminOrders";
import Pricing from "./Pricing";
import SiteContent from "./SiteContent";
import Users from "./Users";
import Inbox from "./Inbox";

const TABS = [["overview", "Overview", Overview], ["inbox", "Inbox", Inbox], ["hosts", "Hosts", Hosts], ["orders", "Card orders", AdminOrders], ["pricing", "Pricing", Pricing], ["site", "Landing page", SiteContent], ["users", "Users & roles", Users]];

export default function Admin() {
  const { logout, user } = useAuth();
  const [tab, setTab] = useState(() => { const t = new URLSearchParams(window.location.search).get("tab"); return TABS.some((x) => x[0] === t) ? t : "overview"; });
  const C = TABS.find((t) => t[0] === tab)[2];
  return (
    <div className="min-h-screen bg-[#151312] text-[#F9F7F4]" data-testid="admin-page">
      <header className="sticky top-0 z-40 border-b border-[#302B28] bg-[#151312]/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-5 py-3 lg:px-10">
          <div className="flex items-center gap-3"><Logo dark /><span className="rounded-full border border-[#302B28] px-2.5 py-0.5 text-xs text-[#A39E9A]">{user?.role === "admin" ? "Admin" : "Owner"}</span></div>
          <nav className="flex gap-1 overflow-x-auto no-scrollbar">
            {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`} className={`whitespace-nowrap rounded-lg px-3.5 py-2 text-sm font-medium transition-colors duration-200 ${tab === k ? "bg-[#F9F7F4] text-[#151312]" : "text-[#A39E9A] hover:bg-[#1E1A18] hover:text-white"}`}>{l}</button>)}
          </nav>
          <div className="flex items-center gap-2 text-sm">
            <Link to="/dashboard" data-testid="admin-host-area-link" className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-[#A39E9A] hover:text-white"><House /> Host area</Link>
            <span className="hidden text-[#A39E9A] md:inline">{user?.email}</span>
            <button onClick={logout} data-testid="admin-logout-button" className="rounded-lg p-2 text-[#A39E9A] hover:text-white"><SignOut size={18} /></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-10 lg:px-10"><div key={tab} className="rise"><C /></div></main>
    </div>
  );
}
